import React from 'react';
import { Platform } from 'react-native';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { StackNavigationOptions } from '@react-navigation/stack';

import { padding } from '@src/configuration/constants';
import { i18n } from '@src/i18n';
import headerBackImage from '@src/navigation/headerBackImage';

const useStackScreenOptions = () => {
  const theme = useTheme();

  return React.useMemo<StackNavigationOptions>(
    () => ({
      headerBackTitle: i18n._(t`Back`),
      headerTruncatedBackTitle: i18n._(t`Back`),
      headerTitleAlign: 'center',
      headerTitleStyle: {
        fontFamily: theme.fonts.medium.fontFamily,
        fontWeight: theme.fonts.medium.fontWeight,
      },
      headerBackTitleStyle: {
        headerTitleAlign: 'center',
        fontFamily: theme.fonts.regular.fontFamily,
        fontWeight: theme.fonts.regular.fontWeight,
      },
      headerStyle: {
        borderBottomWidth: 0,

        ...Platform.select({
          android: {
            elevation: 0,
          },
          ios: {
            shadowColor: theme.colors.backdrop,
            shadowOffset: { width: 0, height: 2 },
            shadowRadius: 2,
            shadowOpacity: 0.3,
          },
          web: {
            elevation: 0,
            boxShadow: `${theme.colors.onBackground} 0px 2px 8px -4px`,
          },
        }),
      },
      headerLeftContainerStyle: {
        marginLeft: padding / 2,
      },
      headerRightContainerStyle: {
        marginRight: padding / 2,
      },
      headerBackImage,
      title: i18n._(t`Youtopin`),
    }),
    [
      theme.colors.backdrop,
      theme.colors.onBackground,
      theme.fonts.medium.fontFamily,
      theme.fonts.medium.fontWeight,
      theme.fonts.regular.fontFamily,
      theme.fonts.regular.fontWeight,
    ]
  );
};

export default useStackScreenOptions;
